import userConstants from "../_constants/userConstants";
import { concat } from "lodash";
import { updateObject } from "../_utils";
import notificationConstants from "../_constants/notificationConstants";

const initialState = {
  isLoading: false,
  initialUrl: "/",
  info: {},
  error: null,
  partnerPreference: {},
  profile: {},
  mobile: {},
  privacy: {},
  topConnected: [],
  images: [],
  notifications: [],
  newMembers: [],
  profileVisitors: null,
  notificationLastResult: null
};

/* ---------------------------------------------------
      AUTHENTICATION STARTED
  ----------------------------------------------------- */
const authenticationStarted = (state, action) => {
  return updateObject(state, {
    isLoading: true
  });
};
/* ---------------------------------------------------
      AUTHENTICATION AUTHENTICATION_SUCCESSFULL
  ----------------------------------------------------- */
const authenticationSuccessfull = (state, action) => {
  const { user, url = "/" } = action.payload;
  return updateObject(state, {
    isLoading: false,
    info: user,
    initialUrl: url
  });
};
/* ---------------------------------------------------
      AUTHENTICATION FAILED
  ----------------------------------------------------- */
const authenticationFailed = (state, action) => {
  return updateObject(state, {
    isLoading: false,
    info: {},
    error: action.payload
  });
};

/* ---------------------------------------------------
      GET PARTNER PREFERENCE
  ----------------------------------------------------- */
const getPartnerPreference = (state, action) => {
  return updateObject(state, {
    partnerPreference: action.payload
  });
};

/* ---------------------------------------------------
      GET USER PROFILE
  ----------------------------------------------------- */
const getUserProfile = (state, action) => {
  return updateObject(state, {
    profile: action.payload
  });
};
/* ---------------------------------------------------
      GET USER INFORMATION
  ----------------------------------------------------- */
const getUserInformation = (state, action) => {
  const { user } = action.payload;
  return updateObject(state, {
    info: user
  });
};
/* ---------------------------------------------------
      GET PRIVACY SETTING
  ----------------------------------------------------- */
const getPrivacySetting = (state, action) => {
  return updateObject(state, {
    privacy: action.payload
  });
};
/* ---------------------------------------------------
GET TOP CONNECTED MEMBERS
----------------------------------------------------- */
const getTopConnectedMembers = (state, action) => {
  return updateObject(state, { topConnected: action.payload });
};
/* ---------------------------------------------------
      GET GALLERY IMAGES
  ----------------------------------------------------- */
const getGalleryImages = (state, action) => {
  return updateObject(state, { images: action.payload });
};
/* ---------------------------------------------------
      UPLOAD PROFILE PICTURE
  ----------------------------------------------------- */
const uploadProfilePicture = (state, action) => {
  return updateObject(state, {
    profile: updateObject(state.profile, {
      imageURL: action.payload
    })
  });
};
/* ---------------------------------------------------
      CHANGE NOTIFICATION LAST RESULT
  ----------------------------------------------------- */
const changeNotificationLastResult = (state, action) => {
  return updateObject(state, { notificationLastResult: action.payload });
};
/* ---------------------------------------------------
      GET NOTIFICATIONS LIST
  ----------------------------------------------------- */
const getNotificationsList = (state, action) => {
  return updateObject(state, { notifications: action.payload });
};
/* ---------------------------------------------------
      GET NOTIFICATIONS LIST
  ----------------------------------------------------- */
const loadMoreNotifications = (state, action) => {
  return updateObject(state, {
    notifications: concat(state.notifications, action.payload)
  });
};
/* ---------------------------------------------------
      GET MOBILE NUMBER
  ----------------------------------------------------- */
const getMobileNumber = (state, action) => {
  return updateObject(state, {
    mobile: action.payload
  });
};
/* ---------------------------------------------------
      GET NEW JOINED MEMBERS
  ----------------------------------------------------- */
const getNewJoinedMembers = (state, action) => {
  return updateObject(state, {
    newMembers: action.payload
  });
};

/* ---------------------------------------------------
      CLEAR NEW JOINED MEMBERS
  ----------------------------------------------------- */
const clearNewJoinedMembers = (state, action) => {
  return updateObject(state, {
    newMembers: []
  });
};

/* ---------------------------------------------------
      GET TOP PROFILE VISITORS  
  ----------------------------------------------------- */
const getTopProfileVisitors = (state, action) => {
  return updateObject(state, {
    profileVisitors: action.payload
  });
};

/* ---------------------------------------------------
        CLEAR TOP PROFILE VISITORS  
    ----------------------------------------------------- */
const clearTopProfileVisitors = (state, action) => {
  return updateObject(state, {
    profileVisitors: null
  });
};

/* ---------------------------------------------------
      SIGN OUT
  ----------------------------------------------------- */
const signOut = (state, action) => {
  return initialState;
};

/* ---------------------------------------------------
      REDUCER
  ----------------------------------------------------- */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case userConstants.AUTHENTICATION_STARTED:
      return authenticationStarted(state, action);
    case userConstants.AUTHENTICATION_SUCCESSFULL:
      return authenticationSuccessfull(state, action);
    case userConstants.AUTHENTICATION_FAILED:
      return authenticationFailed(state, action);
    case userConstants.GET_PARTNER_PREFERENCE:
      return getPartnerPreference(state, action);
    case userConstants.GET_USER_PROFILE:
      return getUserProfile(state, action);
    case userConstants.GET_USER_INFORMATION:
      return getUserInformation(state, action);
    case userConstants.GET_PRIVACY_SETTING:
      return getPrivacySetting(state, action);
    case userConstants.GET_TOP_CONNECTED_MEMBERS:
      return getTopConnectedMembers(state, action);
    case userConstants.GET_GALLERY_IMAGES:
      return getGalleryImages(state, action);
    case userConstants.UPLOAD_PROFILE_PICTURE:
      return uploadProfilePicture(state, action);
    case notificationConstants.CHANGE_NOTIFICATION_LAST_RESULT:
      return changeNotificationLastResult(state, action);
    case notificationConstants.GET_NOTIFICATIONS_LIST:
      return getNotificationsList(state, action);
    case notificationConstants.LOAD_MORE_NOTIFICATIONS:
      return loadMoreNotifications(state, action);
    case userConstants.GET_MOBILE_NUMBER:
      return getMobileNumber(state, action);
    case userConstants.GET_NEW_JOINED_MEMBERS:
      return getNewJoinedMembers(state, action);
    case userConstants.CLEAR_NEW_JOINED_MEMBERS:
      return clearNewJoinedMembers(state, action);
    case userConstants.GET_TOP_PROFILE_VISITORS:
      return getTopProfileVisitors(state, action);
    case userConstants.CLEAR_TOP_PROFILE_VISITORS:
      return clearTopProfileVisitors(state, action);
    case userConstants.SIGN_OUT:
      return signOut(state, action);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/_reducers/userReducer.js